import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { motion } from "motion/react";
import { memo } from "react";
const animationSettings = {
    type: "ease-in-out",
    repeat: Infinity,
    repeatType: "reverse",
    duration: 2
};
export const Animated404 = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex font-gelica text-[72px] font-extralight text-blue-12",
        children: [
            /*#__PURE__*/ _jsx(motion.p, {
                animate: {
                    y: [
                        -9,
                        0
                    ]
                },
                transition: animationSettings,
                children: "4"
            }),
            /*#__PURE__*/ _jsx(motion.p, {
                animate: {
                    y: [
                        0,
                        -8
                    ]
                },
                transition: animationSettings,
                children: "0"
            }),
            /*#__PURE__*/ _jsx(motion.p, {
                animate: {
                    y: [
                        -18,
                        -9
                    ]
                },
                transition: animationSettings,
                children: "4"
            })
        ]
    });
});
Animated404.displayName = "Animated404";
